import React from 'react';

const DataTable = ({ columns, data, onRowClick, onActionClick }) => {
    return (
        <div className='device_table'>
            <table>
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th
                                key={index}
                                style={col.headerStyle || {}}
                            >
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((item, index) => (
                            <tr className="device_tr" key={index}>
                                {columns.map((col, colIndex) => (
                                    <td
                                        key={colIndex}
                                        style={col.cellStyle || {}}
                                        onClick={() =>
                                            col.isAction ? onActionClick?.(item) : onRowClick?.(item)
                                        }
                                        className={col.isAction ? 'action' : ''}
                                    >
                                        {col.render ? col.render(item) : item[col.key]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center' }}>No data available</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default DataTable;
